/** @format */

import {
  ChangeDetectionStrategy,
  Component,
  inject,
  viewChild,
  AfterViewInit,
  DestroyRef,
} from '@angular/core';

import { AsyncPipe } from '@angular/common';
import { HmfSnackbarComponent } from '@dsg-tech/homefield-angular';
import { ProductListSnackbarService } from '@plp/data-access/services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'plp-components-product-list-snackbar',
  imports: [HmfSnackbarComponent, AsyncPipe],
  templateUrl: 'product-list-snackbar.component.html',
  styleUrl: './product-list-snackbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductListSnackbarComponent implements AfterViewInit {
  private readonly snackbarService = inject(ProductListSnackbarService);
  private readonly destroyRef = inject(DestroyRef);

  private readonly hmfSnackbar = viewChild.required<HmfSnackbarComponent>('snackbar');

  readonly snackbarMessage$ = this.snackbarService.snackbar$;

  ngAfterViewInit() {
    this.snackbarMessage$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((msg: string) => {
      if (msg) {
        this.triggerSnackbar();
      } else {
        this.closeSnackbar();
      }
    });
  }

  private triggerSnackbar(): void {
    if (this.hmfSnackbar()) {
      this.hmfSnackbar().openSnackbar();
      setTimeout(() => {
        this.closeSnackbar();
      }, this.hmfSnackbar().dismissDelay() * 1000);
    }
  }

  private closeSnackbar(): void {
    if (this.hmfSnackbar()) {
      this.hmfSnackbar().closeSnackbar();
    }
  }
}
